var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const SpeakerComponent = ({ speaker }) => {
    return (_jsxs("div", { className: "m-1 px-3 py-1 primaryColor text-[12px] rounded-2xl inline-flex items-center bg-white border border-solid border-white", children: [_jsx("i", { className: "pnm-mic-unmute text-[10px] secondaryColor ltr:mr-2 rtl:ml-2" }), speaker.name] }));
};
_react_refresh_temp_1 = SpeakerComponent;
$RefreshReg$(_react_refresh_temp_1, "SpeakerComponent");
export default SpeakerComponent;
